import React from "react";
import { CategoryButton } from "../types/categories";
import { IconButton, Tooltip, TablePagination } from "@mui/material";
import { Edit, DeleteOutline } from "@mui/icons-material";
import CommonTable, { HeadCell } from "../../../../../business-types/grocery/components/CommonTable";
import { DEFAULT_ROWS_PER_PAGE_OPTIONS } from "src/business-types/grocery/hooks/tableConfig";

type CategoryRow = {
  id: string;
  sno: number;
  name: string;
  productCount: number;
  Actions: JSX.Element;
};

interface CategoryTableProps {
  categories: CategoryButton[];
  page: number;
  rowsPerPage: number;
  totalRecords: number;
  showDeleted: boolean;
  onPageChange: (newPage: number) => void;
  onRowsPerPageChange: (newRowsPerPage: number) => void;
  onEdit: (id: string, name: string) => void;
  onDelete: (id: string, name: string) => void;
}

const CategoryTable: React.FC<CategoryTableProps> = ({
  categories,
  page,
  rowsPerPage,
  totalRecords,
  showDeleted,
  onPageChange,
  onRowsPerPageChange,
  onEdit,
  onDelete
}) => {
const rows: CategoryRow[] = (categories ?? []).map((item, index) => ({
  id: item._id.$oid,
  sno: page * rowsPerPage + index + 1,
  name: item.name,
  productCount: Number(item.productCount),
  Actions: (
    <>
      <Tooltip title="Edit" placement="bottom" arrow>
        <IconButton
          disabled={showDeleted}
          onClick={() => onEdit(item._id.$oid, item.name)}
        >
          <Edit style={{ color: showDeleted ? "gray" : "black" }} />
        </IconButton>
      </Tooltip>

      <Tooltip title="Delete" placement="bottom" arrow>
        <IconButton
          disabled={showDeleted}
          onClick={() => onDelete(item._id.$oid, item.name)}
        >
          <DeleteOutline style={{ color: showDeleted ? "gray" : "red" }} />
        </IconButton>
      </Tooltip>
    </>
  ),
}));



  const headCells: HeadCell<CategoryRow>[] = [
    { id: "sno", label: "S.No" },
    { id: "name", label: "Category Name" },
    { id: "productCount", label: "Product Count", numeric: true, align: "center" },
    { id: "Actions", label: "Actions", align: "center" },
  ];

  return (
    <div className="thin-scrollbar shadow-inner rounded-lg p-1 bg-white w-[95%] overflow-y-auto">
      <CommonTable<CategoryRow>
        // key={rowsPerPage}
        data={rows}
        headCells={headCells}
        showToolbar={false}
        denseDefault={false}
        title="Categories"
        pageSize={rowsPerPage}
        pagenation={false}
        selectable={false}
        className="w-full"
      />

      <div className="flex justify-end mr-8 mt-2">
        <TablePagination
          component="div"
          count={totalRecords}
          page={page}
          onPageChange={(_, newPage) => onPageChange(newPage)}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={(e) => {
            const newSize = parseInt(e.target.value, 10);
            onRowsPerPageChange(newSize);
            onPageChange(0); // reset to first page
          }}
          rowsPerPageOptions={DEFAULT_ROWS_PER_PAGE_OPTIONS}
        />
      </div>
    </div>
  );
};

export default CategoryTable;
